export const removeCoupon = (
  couponCode: string,
  removePromoCode: (promoCodeId: string) => void,
  couponItems: { code: string; couponItemId: string }[]
) => {
  const promoFound = couponItems.find(
    (cI: { code: string; couponItemId: string }) => cI.code === couponCode
  )
  if (promoFound) {
    removePromoCode && removePromoCode(promoFound.couponItemId)
  }
}
